/**
 * Selection group helpers shared between the backend (which normalizes before
 * persisting) and the dashboard (which normalizes before submitting/comparing)
 * so both agree on the canonical form of a handle.
 */

/**
 * Normalizes a raw selection group to its canonical form: trimmed and
 * lowercased.
 */
export const normalizeSelectionGroup = (group?: string | null): string =>
  (group || "").trim().toLowerCase();
